<template>
    <div>
        <b-modal
            id="modalHistory"
            ref="modalHistory"
            :lazy="true"
            :scrollable="true"
            title-tag="h2"
            hide-footer
            title="History"
            body-class="bg-white pr-4"
        >
            <section
                v-for="(history, key) in appointment_history"
                :key="history.id"
                class="cd-container"
            >
                <div>
                    <b-row>
                        <b-col cols="2">
                            <div
                                class="timeline"
                                :class="
                                    key == appointment_history.length - 1
                                        ? 'timeline-last'
                                        : ''
                                "
                            >
                                <i
                                    :class="statusClass(history.status_id)"
                                    class="famfamfam-silk icon-timeline"
                                ></i>
                            </div>
                        </b-col>
                        <b-col cols="10" class="timeline-content">
                            <b-row>
                                <b-col cols="6" class="p-0"
                                    ><h5 class="card-title p-0">
                                        {{ history.title }}
                                    </h5></b-col
                                >
                                <b-col cols="6" class="p-0 text-right">
                                    <small>
                                        {{ history.update_at }} by
                                        {{ history.update_by }}
                                    </small>
                                </b-col>
                            </b-row>
                            <b-row
                                class="pt-1"
                                :class="
                                    key != appointment_history.length - 1
                                        ? 'history-content'
                                        : ''
                                "
                            >
                                <p
                                    style="word-break: break-all;"
                                    v-html="getDescription(history)"
                                ></p>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
            </section>
        </b-modal>
    </div>
</template>
<style scoped lang="scss">
.card-title {
    font-size: 0.85rem;
    padding-top: 3%;
    color: #303e49;
}

.history-content {
    border-bottom: 1px dotted #ccc;
    margin-bottom: 1rem;
}

.timeline {
    height: 100%;
    margin-left: 50%;
    border-left: 1px solid rgba(48, 62, 73, 0.5);
}

.timeline-last {
    height: 1rem;
}

.timeline-content {
    margin-left: -15px;
    padding-right: 0px;
}

.icon-timeline {
    position: relative;
    top: -2px;
    margin-left: -0.73em;
    background-color: #ffffff;
}
</style>

<script>
import ScheduleHelper from "@/module/schedule/helper";
export default {
    mixins: [ScheduleHelper],
    data() {
        return {
            appointment_history: []
        };
    },
    methods: {
        open(event) {
            this.getData(event.id);
        },
        getData(id) {
            let self = this;
            this.$http
                .get(process.env.SCHEDULE_SERVICE + "appointment-history/" + id)
                .then(function (response) {
                    self.appointment_history = response.data.response.resources;
                    self.$refs.modalHistory.show();
                });
        },
        getDescription(history) {
            var summary = "";
            if (history.description) {
                history.description.forEach(element => {
                    if (element.value) {
                        summary +=
                            "<br /><b>" +
                            this._replaceTimestamp(element.label) +
                            "</b>: " +
                            element.value;
                    } else {
                        summary +=
                            this._replaceTimestamp(element.label) + "<br />";
                    }
                });
            }
            return summary;
        }
    }
};
</script>
